import {makeAutoObservable, autorun} from 'mobx';
import {RootWidgetComponentIds} from '../../../config/constants';
import {RootStore} from '../../../stores/RootStore';
import {getMediaItems} from '../../product-service/media/getMediaItems';

export const bindGalleryProps = (rootStore: RootStore) => {
  const {$bind, $w} = rootStore.controllerParams;

  const galleryStore = makeAutoObservable({
    get items() {
      return getMediaItems(rootStore.$state);
    },
    get isEmpty() {
      return galleryStore.items.length === 0;
    },
  });

  autorun(async () => {
    if (!galleryStore.isEmpty) {
      // @ts-expect-error -missing type, waiting for Izaac Ayelin to fix this
      $w(RootWidgetComponentIds.Gallery)?.navigateToIndex?.(0);
    }
  });

  $bind(RootWidgetComponentIds.Gallery, {
    items: () => galleryStore.items,
  });
};
